import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import CoverPage from "./CoverPage";
import StudentLogin from "./studentlogin";
import LoginProfiles from "./loginProfiles";
import VolunteerLogin from "./volunteerlogin";
import DonorLogin from "./donorlogin";
import Register from "./register";
import StudentForm from "./studentform";
import StudentDashboard from "./studentdashboard";
import DonorDashboard from "./DonorDashboard"; // <-- 1. IMPORT DonorDashboard
import AdminDashboard from "./AdminDashboard"; // admin dashboard
import Adminlogin from "./adminlogin";
import VolunteerDashboard from "./VolunteerDashboard";
import ResetPassword from "./ResetPassword";




function App() {
  return (
    <Router>
      <Routes>
        {/* Cover page shows first */}
        <Route path="/" element={<CoverPage />} />

        {/* Login profiles page */}
        <Route path="/login" element={<LoginProfiles />} />

        {/* Volunteer auth */}
        <Route path="/volunteerlogin" element={<VolunteerLogin />} />
        <Route path="/volunteer-dashboard" element={<VolunteerDashboard />} />
        <Route path="/reset-password" element={<ResetPassword />} />


        <Route path="/donorlogin" element={<DonorLogin />} />
        <Route path="/register" element={<Register />} />

        {/* Student flow */}
     <Route path="/studentform" element={<StudentForm />} />
<Route path="/studentform/:id" element={<StudentForm />} />

        <Route path="/student-login" element={<StudentLogin />} />
        <Route path="/student-dashboard" element={<StudentDashboard />} />
        
        {/* Donor flow */}
        <Route path="/donor-dashboard" element={<DonorDashboard />} /> {/* <-- 2. ADD NEW ROUTE */}
        <Route path="/admin-dashboard" element={<AdminDashboard />} />
        <Route path="/adminlogin" element={<Adminlogin />} />

      </Routes>
    </Router>
  );
}

export default App;
